import React from "react";

export default function LogoutModal({ open, onClose, onConfirm }) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 w-full max-w-sm shadow-lg relative">
                <button
                    className="absolute top-2 right-4 text-xl text-gray-400 hover:text-gray-600"
                    onClick={onClose}
                >
                    &times;
                </button>

                {/* Icon */}
                <div className="flex justify-center mb-4">
                    <div className="bg-red-100 rounded-full p-4">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-8 w-8 text-red-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h6a2 2 0 012 2v1"
                            />
                        </svg>
                    </div>
                </div>

                <h2 className="text-xl font-bold text-center text-gray-800 mb-1">
                    Logout
                </h2>
                <p className="text-center text-gray-500 mb-6 text-sm">
                    Are you sure you want to log out? Any active testing session will be
                    disconnected.
                </p>

                <div className="flex gap-3">
                    <button
                        className="flex-1 border border-gray-300 text-gray-700 py-2 rounded font-semibold hover:bg-gray-50 transition"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="flex-1 bg-red-500 text-white py-2 rounded font-semibold hover:bg-red-600 transition"
                        onClick={onConfirm}
                    >
                        Yes, Logout
                    </button>
                </div>
            </div>
        </div>
    );
}
